import { defineStore } from 'pinia';
import { useUriStore } from '@/pinia/general/uri';
import { useErrorStore } from '@/pinia/helpers';
import { computed, ref } from 'vue';
import axios from 'axios';
interface IDataEnv {
  [key: string]: string | boolean;
}
export const useEnvStore = defineStore('env', () => {
  const env = ref<IDataEnv>({});
  const isEnv = computed(() => Boolean(Object.keys(env.value).length));

  const flag = (code: string): boolean | string | undefined => {
    const f = Object.keys(env.value).find((key) => key === code);
    return f ? env.value[code] : undefined;
  };

  const isDarkTheme = computed(() => flag('DARK_THEME_ACTIVATE'));
  const isConveyorIndividuals = computed(() => flag('CONVEYOR_INDIVIDUALS'));
  const isNewQuestionnaireMode = computed(() => flag('IS_NEW_QUESTIONNAIRE_MODE'));
  const cardPadding = computed(() => flag('CARD_PADDING'));

  function setEnv(data: IDataEnv) {
    env.value = data;
  }

  async function getEnv() {
    if (isEnv.value) return;
    const uriStore = useUriStore();
    const errorStore = useErrorStore();

    const res = await axios.get<IDataEnv>(uriStore.baseURL + uriStore.env).catch((e) => {
      e.uri = uriStore.env;
      errorStore.setError(e);
    });
    if (!res) return;
    setEnv({ ...res.data, CARD_PADDING: '10px' });
  }

  return { env, isEnv, flag, getEnv, setEnv, isConveyorIndividuals, isNewQuestionnaireMode, isDarkTheme, cardPadding };
});
